
import React, { useEffect } from 'react';
import HeroSection from '@/components/HeroSection';
import WhyChooseUs from '@/components/WhyChooseUs';
import ProblemSolutionSection from '@/components/ProblemSolutionSection';
import CtaSection from '@/components/CtaSection';
import AnimatedTagline from '@/components/AnimatedTagline';
import SEOHead from '@/components/SEO/SEOHead';
import { seoConfig } from '@/config/seoConfig';
import { generateOrganizationSchema } from '@/utils/schemaUtils';
import HorizontalImageSlider from '@/components/HorizontalImageSlider';
import UnifiedServicesShowcase from '@/components/UnifiedServicesShowcase';
import ProofSection from '@/components/ProofSection';
import { motion } from 'framer-motion';

const Index = () => {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Generate structured data for the homepage
  const organizationSchema = generateOrganizationSchema();

  return (
    <>
      <SEOHead 
        {...seoConfig.home}
        structuredData={organizationSchema}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <main>
          <HeroSection />
          <AnimatedTagline />
          <WhyChooseUs />
          <HorizontalImageSlider />
          <ProblemSolutionSection />
          <UnifiedServicesShowcase />
          <ProofSection />
          <CtaSection />
        </main>
      </motion.div>
    </>
  );
};

export default Index;
